import React from "react";
import { useNavigate } from "react-router-dom";
import Banner from "../components/layout/Banner";
import { AUTH_INTENT_DETAILS, buildLaunchSearch, getLaunchContext } from "../utils/auth/intent";

const START_OPTIONS = ["application", "broker", "client", "staff"];

export default function StartApplication() {
    const navigate = useNavigate();
    const launchContext = getLaunchContext();

    const handleSelect = (intent) => {
        navigate(`/login${buildLaunchSearch({ ...launchContext, intent })}`);
    };

    return (
        <div className="min-h-screen bg-surface flex items-center justify-center px-4 py-6">
            <div className="bg-white shadow-card rounded-[32px] min-h-[520px] px-8 py-10 w-full max-w-3xl animate-fadeIn">
                <Banner />

                <div className="mt-10 text-center">
                    <p className="text-sm font-semibold uppercase tracking-[0.28em] text-secondary">
                        Secure Access
                    </p>
                    <h1 className="mt-4 text-3xl md:text-4xl font-bold text-primary">
                        Choose where you want to go
                    </h1>
                    <p className="mt-4 text-lg text-secondary leading-relaxed max-w-2xl mx-auto">
                        Select your destination first, then we will send you through the correct secure login flow and handoff.
                    </p>
                </div>

                <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-4">
                    {START_OPTIONS.map((intent) => {
                        const details = AUTH_INTENT_DETAILS[intent];

                        return (
                            <button
                                key={intent}
                                type="button"
                                onClick={() => handleSelect(intent)}
                                className="rounded-[28px] border border-lightBorder bg-white px-6 py-6 text-left transition-all duration-200 hover:-translate-y-0.5 hover:border-primary hover:bg-surface focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                            >
                                <div className="flex items-center justify-between gap-4">
                                    <span className="text-2xl font-bold text-primary">{details.label}</span>
                                    <span className="rounded-full bg-surface px-3 py-1 text-xs font-semibold uppercase tracking-wide text-secondary">
                                        Open
                                    </span>
                                </div>
                                <p className="mt-3 text-base leading-relaxed text-secondary">
                                    {details.description}
                                </p>
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
